import { FETCH_QUERIES_NAME } from '@common/constants';
import { useQuery } from '@tanstack/react-query';
import { AxiosErrorResponse } from '@core/error.models';
import { getAllTransmittalItemDocumentTypesAsync } from './transmittalItemDocumentType.services';
import { IProjectTransmittalItemDocumentType } from './transmittalItemDocumentType.models';

export const useFetchAllTransmittalItemDocumentTypes = () => {
  return useQuery<IProjectTransmittalItemDocumentType[], AxiosErrorResponse>(
    [FETCH_QUERIES_NAME.TRANSMITTAL_ITEM_DOCUMENT_TYPES],
    async () => {
      const result = await getAllTransmittalItemDocumentTypesAsync();
      return result.items || [];
    },
    {},
  );
};
